import RecordView from "@/components/record/RecordView";
import { Module, NO_DATA } from "@/constants";
import { usePayrollQuery } from "@/modules/payrolls/hooks/usePayrollQuery";
import { generatePayrollDisplayName } from "@/modules/payrolls/utils/generatePayrollDisplayName";
import { ReadPayroll } from "@/types/payroll";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { usePayrollParams } from "../hooks/usePayrollParams";
import { PayrollStatusBadge } from "@/components/PayrollStatusBadge";
import { PayrollStatus } from "@/schemas/payroll";
import { formatDateTime } from "@/lib/utils/formatters";

interface PayrollRecordViewProps {
  actions?: React.ReactNode[];
  className?: string;
}

export const PayrollRecordView = memo(
  ({ className, actions }: PayrollRecordViewProps) => {
    const { payrollId } = usePayrollParams();
    const query = usePayrollQuery(payrollId);
    const { t } = useTranslation();

    return (
      <RecordView<ReadPayroll>
        query={query}
        translationKey={Module.Payrolls}
        header={(data) => generatePayrollDisplayName(data)}
        actions={actions}
        className={className}
        isOpen={true}
      >
        <RecordView.Field name="period" />
        <RecordView.Field
          name="project_depends_on"
          renderer={(value) => t(`projectDependsOn.${value}`)}
        />
        <RecordView.Field
          name="payroll_version"
          renderer={(value) => t(`payrolls.enum.payroll_version.${value}`)}
        />
        <RecordView.Field
          name="payroll_status"
          renderer={(value: PayrollStatus) => (
            <PayrollStatusBadge status={value} />
          )}
        />
        <RecordView.Field
          name="split"
          renderer={(value) => t(value ? "common.yes" : "common.no")}
        />
        <RecordView.Field
          name="created_at"
          renderer={(value) => (value ? formatDateTime(value) : NO_DATA)}
        />
        <RecordView.Field
          name="updated_at"
          renderer={(value) => (value ? formatDateTime(value) : NO_DATA)}
        />
      </RecordView>
    );
  },
);
